<ng-container *ngIf="this.hotelData != undefined">
    <div class="flex flex-col border border-solid border-black-50 shadow-sm rounded-2xl bg-white w-[300px] lg:w-auto">
        <div class="h-[166px]">
            <img *ngIf="hotelData?.Pictures" class="object-cover w-full h-full rounded-t-2xl"
                [src]="hotelData?.Pictures[0].Jpg" [alt]="hotelData?.Pictures[0]?.Alt">
        </div>
        <div class="p-4 text-right">
            <h4 class="font-medium">{{hotelData?.FullName}}</h4>
            <!-- <div class="flex items-center gap-2">
                <i class="ico-Star-bold text-xl text-muted"></i>
                <span class="text-muted text-sm">{{ hotelData?.Star?.GradeId }} ستاره</span>
            </div> -->
            <div class="flex items-end justify-between gap-2 mt-4">

                <a [href]="hotelData?.HotelUrl">
                    <button
                        class="bg-blue-500 min-w-[91px] min-h-[36px] flex items-center justify-center rounded-lg text-white font-medium">
                        {{searchBoxService.accommodation() == 'ecolodge' ? 'رزرو اقامتگاه' : 'رزرو هتل'}}
                    </button>
                </a>


                <div class="flex flex-col gap-2 md:h-full md:pr-4 justify-end w-full">
                    <!-- <ng-container *ngIf="!dataSource?.FullCapacity; else fullCapacityBtn"> -->
                    <div *ngIf="hotelData?.Price?.OldPrice && hotelData?.Price?.IhoPrice"
                        class="flex w-full items-center justify-end gap-2">
                        <span
                            class="price-off mx-2 after:content-[''] line-through-price text-black-200 text-xs !font-normal">{{
                            hotelData?.Price?.BoardPrice | toToman | number : '2.' }}</span>
                        <div *ngIf="
              hotelData?.DiscountBalloon?.Discount &&
              +hotelData.DiscountBalloon?.Discount! >= 5
            " class="badge-precent bg-green-50 px-3 py-1 rounded-lg">
                            <span class="text-sm text-green-800 !font-medium">{{ hotelData?.DiscountBalloon?.Discount
                                }}%</span>
                        </div>
                    </div>

                    <div *ngIf="hotelData?.Price?.IhoPrice" class="flex w-full items-center gap-1 justify-end">
                        <span class="text-xs text-muted">{{
                            hotelData?.Price?.StartingText
                            }}</span>
                        <span class="text-black-500 text-xl font-bold">{{
                            hotelData?.Price?.IhoPrice | toToman | number : '2.'
                            }}</span>
                        <span class="text-xs text-muted">تومان</span>
                    </div>


                    <!-- </ng-container> -->

                    <ng-template #fullCapacityBtn>
                        <!-- <div *ngIf="ds.Price?.OldPrice && ds.Price.IhoPrice"
                        class="flex w-full items-center justify-end gap-2">
                        <span
                            class="price-off mx-2 after:content-[''] text-black-200 line-through-price text-xs !font-normal">{{
                            ds.Price?.BoardPrice | toToman | number : '2.' }}</span>
                        <div class="badge-precent bg-green-50 px-3 py-1 rounded-lg">
                            <span class="text-sm text-green-800 !font-medium">{{ ds?.DiscountBalloon?.Discount
                                }}%</span>
                        </div>
                    </div>

                    <div class="flex w-full items-center gap-1 justify-end">
                        <span class="text-xs text-muted">{{
                            ds?.Price?.StartingText
                            }}</span>
                        <span class="text-black-500 text-xl font-bold">{{
                            ds?.Price?.IhoPrice | toToman | number : '2.'
                            }}</span>
                        <span class="text-xs text-muted">تومان</span>
                    </div>

                    <button mat-stroked-button color="warn"
                        class="flex icon-button w-full !h-11 items-center justify-center font-semibold gap-2 text-red-500">
                        <i class="ico-LeftOver text-2xl text-red-500"></i>
                        <span class="text-base text-red-500">تکمیل ظرفیت</span>
                    </button> -->
                    </ng-template>
                </div>

            </div>
        </div>
    </div>
</ng-container>